export const numberRange = (start: number, end: number) =>
  Array.from(Array(end - start + 1).keys()).map(x => x + start);
